import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox } from '@UILayer/Inputs/Checkbox';
import { DOM_ID } from '@UILayer/UILayer.types';

// REDUX
import { useAppDispatch, useAppSelector } from '@Managers/Redux/Hooks';
import { getWCAMode, setWCAMode } from '@Managers/Redux/AppState/AppState';

import ConfigLoader from '@ConfigLoader/ConfigLoader';
import { EConfigurationNames } from '@ConfigLoader/ConfigFiles';

// CSS
import styles from '@UILayer/UILayer.scss';

// IMAGES
import wcaLogo from '@Images/universal-access.png';

//PANELS & VIEWS

const PreloaderWCAMode: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const wcaMode = useAppSelector(getWCAMode);

    useEffect(() => {}, []);

    function toggleWCAMode() {
        dispatch(setWCAMode(!wcaMode));
    }

    return (
        <>
            {ConfigLoader.getConfiguration(EConfigurationNames.UI_LAYER).wcaMode && (
                <div className={styles.prealoder_checkbox}>
                    <img className={styles.prealoder_checkbox_icon} src={wcaLogo} alt="WCA 2.1 Conformance logo" />
                    <Checkbox
                        id={DOM_ID.CHECKBOX_WCA_PRERLOADER}
                        checked={wcaMode}
                        ariaLabel={t('WCA_TOGGLE_WEB_CONTENT_ACCESSIBILITY_MODE')}
                        onChange={toggleWCAMode}
                        showLabel={false}
                    />
                </div>
            )}
        </>
    );
};

export default PreloaderWCAMode;
